angular.module('aprima-legacy-common').run(['CustomModuleRunService', function(CustomModuleRunService) {
    'use strict';
    CustomModuleRunService.add(['$rootScope', 'ErrorService', 'RequestTypes', '$transitions', function ($rootScope, ErrorService, RequestTypes, $transitions) {

    $rootScope.requestTypes = RequestTypes;

    $rootScope.addHttpError = function (httpResponse, messages, type) {
        var innerScope = this;

        if(!httpResponse.isAborted) {
            return ErrorService.addHttpErrorToScope(innerScope, httpResponse, messages, type);
        }

        return httpResponse;
    };

    $rootScope.removeHttpError = function (type) {
        var innerScope = this;
        return ErrorService.removeHttpErrorFromScope(innerScope, type);
    };

    $rootScope.setupDirectiveScope = function setupDirectiveScope($scope) {
        $scope.addHttpError = $rootScope.addHttpError;
        $scope.removeHttpError = $rootScope.removeHttpError;
    };

    $transitions.onSuccess({}, function removeHttpErrors() {
        //http errors were being persisted between page views and caused valid pages to be rendered as if they had an http error
        $rootScope.removeHttpError();
    });

}]);}]);
